module.exports = __webpack_public_path__ + "static/slider-2-2-3e28f2810b39ddc0410a2b29cdcdb421.jpg";